import React from "react";
import { useSize } from "@chakra-ui/react-use-size";
import {
  VStack,
  Heading,
  useBoolean,
  Collapse,
  Button,
  HStack,
} from "@chakra-ui/react";

import { ModuleImage } from "@constants";
import { ImagePopUp } from "./ImagePopUp";

interface IImageGrid {
  images: ModuleImage[];
}

export function ImageGrid({ images, ...delegated }: IImageGrid) {
  const stackRef = React.useRef<HTMLDivElement>(null);
  const { width: stackWidth } = useSize(stackRef) ?? { width: null };
  const stackOverflows = React.useMemo(
    () =>
      stackWidth === null || !images
        ? false
        : stackWidth - images.length * 140 < 0,
    [stackWidth, images],
  );
  const [showMore, { toggle: toggleShowMore }] = useBoolean(false);
  if (!images || images.length === 0) return null;
  return (
    <VStack w="100%" alignItems="flex-start" {...delegated}>
      <Heading as="h3" size="lg" marginTop="16px">
        Gallery
      </Heading>
      <Collapse startingHeight="140px" in={showMore}>
        <HStack wrap="wrap" gap="16px" marginBottom="4px" ref={stackRef}>
          {images.map(({ src, comments, title, timestamp }) => (
            <ImagePopUp
              key={`${title}-${timestamp}`}
              src={src}
              comments={comments}
              title={title}
            />
          ))}
        </HStack>
      </Collapse>
      {stackOverflows ? (
        <Button variant="ghost" onClick={toggleShowMore}>
          Show {showMore ? "Less" : "More"}
        </Button>
      ) : undefined}
    </VStack>
  );
}
